import { z } from "zod/v4";

export const LivestreamViewedActivityMetadata = z.object({
  viewedAt: z.iso.datetime(),
});
export type LivestreamViewedActivityMetadata = z.infer<typeof LivestreamViewedActivityMetadata>;

export const ClipViewedActivityMetadata = z.object({
  clipId: z.string(),
  viewedAt: z.iso.datetime(),
});
export type ClipViewedActivityMetadata = z.infer<typeof ClipViewedActivityMetadata>;

/**
 * A support user asked a camera to compile a full-quality clip over a time
 * range. Records the requested window and the `requestId` that identifies the
 * job, so an audit reader can tie the entry to the compilation it produced.
 */
export const ClipCompilationRequestedActivityMetadata = z.object({
  requestId: z.string(),
  rangeStart: z.iso.datetime(),
  rangeEnd: z.iso.datetime(),
  requestedAt: z.iso.datetime(),
});
export type ClipCompilationRequestedActivityMetadata = z.infer<typeof ClipCompilationRequestedActivityMetadata>;
